import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SubmittingMissingPage from './SubmittingMissingPage';

const SubmittingMissingPageWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Phase 1: Basic navigation functions
  const handleNavigate = (path: string, params?: any) => {
    if (params) {
      // Convert params to query string for web
      const searchParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          searchParams.set(key, String(params[key]));
        }
      });
      navigate(`${path}?${searchParams.toString()}`);
    } else {
      navigate(path);
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  // Phase 2: Props for SubmittingMissingPage (Redux props are now handled by connect)
  const props = {
    navigate: handleNavigate,
    goBack: handleGoBack,
    // Redux props are automatically provided by connect() in the main component
  };

  return <SubmittingMissingPage {...props} />;
};

export default SubmittingMissingPageWrapper;
